export default __webpack_public_path__ + "static/media/HyunJaeCho.6645b57a.jpg";